import styled from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

export const AlertContainer = styled(FlexibleDiv)`
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 15px 10px;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.systemColors.red};
  background-color: ${({ theme }) => theme.colors.systemColors.lightRed};
  margin-top: 10px;
`;

export const AlertText = styled(Typography)`
  width: 90%;
  align-self: center;
`;

export const AlertTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.red};
`;
